<template>
  <div class="bg-[#FCFCFC] p-[14px] rounded-[10px]">
    <div class="flex items-center justify-between gap-[10px] flex-wrap mb-[24px]">
      <div class="flex items-center justify-start gap-[10px] flex-wrap">
        <div class="flex items-center justify-center bg-[#FFECE9] rounded-full size-[44px]">
          <span class="k-eye text-[24px] text-[#F95031]" />
        </div>
        <h2 class="font-medium text-[#000000] mb-0 text-[16px]">
          Campaign Preview
        </h2>
      </div>
      <div class="flex items-center justify-center gap-[8px] p-[4px] rounded-[10px] border-[1px] border-[#E2E8F0]">
        <b-button
          :variant="mode === 'desktop' ? 'primary' : 'ghost'"
          class="!p-[8px] !rounded-[4px] font-semibold text-white"
          @click="switchMode('desktop')"
        >
          <monitor-icon
            size="1.15x"
            :class="[mode !== 'desktop' ? '!text-[#45556C]' : '']"
          />
        </b-button>
        <b-button
          :variant="mode === 'mobile' ? 'primary' : 'ghost'"
          class="!p-[8px] !rounded-[4px] font-semibold text-white"
          @click="switchMode('mobile')"
        >
          <smartphone-icon
            size="1.15x"
            :class="[mode !== 'mobile' ? '!text-[#45556C]' : '']"
          />
        </b-button>
      </div>
    </div>
    <div
      class="bg-[#F1F5F9] rounded-[10px] p-[24px] overflow-x-auto"
    >
      <div
        class="mx-auto bg-white overflow-hidden shadow-[0_3.83px_5.75px_-3.83px_rgba(0,0,0,0.1),0_9.58px_14.37px_-2.87px_rgba(0,0,0,0.1)] transition-all duration-300 ease-in-out"
        :class="[ mode === 'desktop' ? 'w-[862.3px]' : 'w-[420px]']"
      >
        <img
          :src="previewThumbnailUrl"
          alt="thumbnail"
          width="100%"
        >
        <div class="px-[24px] py-[23px]">
          <h3 class="text-[#000] font-medium text-[23px] mb-[9.58px]">
            {{ form.name }}
          </h3>
          <p class="text-[#626262] text-[15.33px] mb-0 pb-[25.87px] border-b-[0.96px] border-[#E2E2E2]">
            {{ form.description }}
          </p>
          <preview-detail
            label="Campaign Info"
          >
            <div class="flex items-start justify-start flex-wrap gap-[24px]">
              <div
                v-for="(itemList, index) in campaignInfo"
                :key="`campaign-info-${index}`"
                class="flex items-center flex-col gap-[23px]"
              >
                <preview-list-item
                  v-for="item in itemList"
                  :key="item.label"
                  :label="item.label"
                >{{ item.formatter ? item.formatter(item.value) : item.value || '-' }}</preview-list-item>
              </div>
            </div>
          </preview-detail>
          <preview-detail
            label="Scope of Works"
            icon="k-briefcase"
          >
            <div
              class="flex items-center flex-col gap-[23px]"
            >
              <preview-list-item
                v-for="item in scopeOfWorks"
                :key="item.label"
                :label="item.label"
              >{{ item.formatter ? item.formatter(item.value) : item.value || '-' }}</preview-list-item>
            </div>
          </preview-detail>
          <preview-detail
            label="Agreements"
            icon="k-receipt-text"
            no-bottom
          >
            <div
              class="flex items-center flex-col gap-[23px]"
            >
              <preview-list-item
                v-for="item in aggreement"
                :key="item.label"
                :label="item.label"
              >{{ item.formatter ? item.formatter(item.value) : item.value || '-' }}{{ item.append }}</preview-list-item>
            </div>
          </preview-detail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MonitorIcon, SmartphoneIcon } from 'vue-feather-icons'
import PreviewListItem from './PreviewListItem.vue'
import PreviewDetail from './PreviewDetail.vue'

export default {
  components: {
    MonitorIcon,
    SmartphoneIcon,
    PreviewListItem,
    PreviewDetail,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      mode: 'desktop',
      previewThumbnailUrl: null,
    }
  },
  computed: {

    campaignInfo() {
      return [[
        { label: 'Link Product', value: this.form.product_link },
        { label: 'Kategori Produk', value: this.form.product_category, formatter: value => this.displayLabel(value) },
        { label: 'Channel', value: this.form.campaign_source, formatter: value => this.displayLabel(value) },
        { label: 'Total Creator', value: this.form.total_creators },
        { label: 'Mininum Followers', value: this.form.min_followers },
      ],
      [
        { label: 'Min GMV', value: this.form.min_gmv },
        { label: 'Domisili', value: this.form.domicile, formatter: value => this.displayLabel(value) },
        { label: 'Jenis Produk', value: this.form.product_type, formatter: value => this.displayLabel(value) },
        { label: 'Tipe Campaign', value: this.form.campaign_type, formatter: value => this.displayLabel(value) },
      ]]
    },
    scopeOfWorks() {
      return [
        { label: 'Tipe Konten', value: this.form.content_type, formatter: value => this.displayLabel(value) },
        { label: 'Jumlah Konten', value: this.form.content_amount },
        { label: 'Brief Konten', value: this.form.content_brief },
      ]
    },
    aggreement() {
      const channel = String(this.form.channel || '').toLowerCase()
      const isMcnOnly = channel.includes('mcn') && !channel.includes('tap')
      if (isMcnOnly) {
        return [
          { label: 'Komisi MCN', value: this.form.commission_mcn, append: '%' },
        ]
      }
      return [
        { label: 'Komisi TAP', value: this.form.commission_tap, append: '%' },
        { label: 'Komisi MCN', value: this.form.commission_mcn, append: '%' },
      ]
    },
  },
  watch: {
    'form.thumbnail': {
      immediate: true,
      handler(val) {
        if (this.previewThumbnailUrl?.startsWith('blob:')) {
          URL.revokeObjectURL(this.previewThumbnailUrl)
        }
        const file = Array.isArray(val) ? val[0] : val
        if (file instanceof File) {
          this.previewThumbnailUrl = URL.createObjectURL(file)
        } else if (typeof file === 'string') {
          this.previewThumbnailUrl = file
        } else {
          this.previewThumbnailUrl = null
        }
      },
    },
  },
  beforeDestroy() {
    if (this.previewThumbnailUrl?.startsWith('blob:')) {
      URL.revokeObjectURL(this.previewThumbnailUrl)
    }
  },
  methods: {
    submitCampaign() {
      this.$emit('submit', this.form)
    },
    switchMode(mode) {
      this.mode = mode
    },
    /**
     * Resolves display label(s) dari value.
     * Untuk multiselect (array), join dengan koma.
     *
     * @param {string|Array} value - nilai dari form state
     * @returns {string} String yang diformat
     */
    displayLabel(value) {
      return Array.isArray(value) ? value.join(', ') : (value || '-')
    },
  },
}
</script>
